import { Component, OnInit, HostListener, OnDestroy } from '@angular/core';
import { DataService } from '../../data.service';
import { License, LicenseResolved } from '../license';
import { AuthService } from '../../users/auth.service';
import { ActivatedRoute } from '@angular/router';
import { Authority } from 'src/app/authorities/authority';
import { Enum } from '../enum';
import { User } from 'src/app/users/user';
import { Observable, Subscription } from 'rxjs';
import { ListHelperService } from 'src/app/shared/list-helper.service';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'pm-license-list',
  templateUrl: './license-list.component.html',
  styleUrls: ['./license-list.component.css'],  
})
export class LicenseListComponent implements OnInit {
  pageTitle = 'NC Business and Occupational License Database';
  licenses : License[];
  authId: number;
  authName: string;
  coordId: string;
  coordName: string;
  errorMessage: string;  
  filterActive: string='';
  enums: any;
  isLoggedInSubscription: Subscription; 

  cols=[
    {name: "licTitle", label: "License"},
    {name: "licenseUpdated", label: "Updated"},
    {name: "flags", label: "Status flags"},    
  ];
  
  terms: string[];

  get searchTerms(): string{
    let val=sessionStorage.getItem('licSearchTerms')||'';
    this.terms=val.split(' '); // Needed? 02/02/20
    return val;
  }
  set searchTerms(val: string) {
    this.terms=val.split(' '); 
    sessionStorage.setItem('licSearchTerms', val);
  }

  constructor(private dataService: DataService, public auth: AuthService, private route: ActivatedRoute, 
    public lh: ListHelperService, private meta: Meta,  private title: Title ) { }
  
  ngOnInit() {
    this.lh.list='lic';
    this.lh.default='licTitle';
    this.meta.updateTag({name: 'keywords', content: ''});
    this.title.setTitle(`All licenses required by state statutes in North Carolina`);
    this.meta.updateTag({name: "description", content: `NC BOLD is a repository for business, occupational and privilege licensing requirements
      maintained by the North Carolina Department of Commerce.`});        
    this.loadLicenses();
  }

  loadLicenses(){
    if (this.auth.isLoggedIn){
        this.dataService.getEnum().subscribe((data: Enum[])=>{
        this.enums=data;
      });
    }    
    this.route.data.subscribe(data => {
//      console.log(data);
      const licenses: any = data.resolvedData;
//      this.errorMessage = licenses.error;
      this.licenses = licenses.license;
      this.lh.array = this.licenses;
      this.lh.orderDesc=!this.lh.orderDesc;
      this.lh.setOrder(this.auth.isLoggedIn?this.lh.listOrder:this.lh.default);
      this.authId=this.route.snapshot.params['authid'];  
      if (this.authId){
          this.dataService.getAuthority(this.authId).subscribe((data: Authority)=>{ 
          this.authName=data.department+(!data.division ||data.division===''?'':'/'+data.division)+(!data.board || data.board===''?'':'/'+data.board);  
        });
      }
      this.coordId=this.route.snapshot.params['coordid'];  
      if (this.coordId){
          this.dataService.getUser(this.coordId).subscribe((data: User)=>{ 
          this.coordName=data.lastName+', '+data.firstName;  
        });
      }   
    });
  }

  @HostListener('window:beforeunload')
    canDeactivate(): Observable<boolean> | boolean {
        this.saveList();  
        return true;
  }
  
  // Match added options in status selector, 255=all bits
  private filterMask={
    "o": 1,
    "t": 2,
    "x": 4,
    "n": 8,
    "z": 255
  };

  filterResults (license: any){
    if (this.auth.isLoggedIn) {
      return (!this.authId || license.authid==this.authId) &&
          (!this.coordId || license.coordid.includes(+this.coordId)) &&
          ( this.filterActive=='' || this.filterActive==license.activeStatus || license.flags&(this.filterMask[this.filterActive]||0)) &&   // Default filter mask is 0
         this.terms.every((term)=>{if (term.length==0) return true; let re=new RegExp(term, 'gi'); return license.licTitle.match(re)||license.keywords.match(re);});
    }
    else return license.inactive!=3 && this.terms.every((term)=>{if (term.length==0) return true; let re=new RegExp(term, 'gi'); return license.licTitle.match(re)||license.keywords.match(re);});   
  }

  filterEnum (name: string){
    return this.enums.filter(e=>e.name==name);
  }

  getEnumVal(name: string, key: string){
    return this.enums.find(f=>f.name==name && f.key==key).value;
  }

  getStatusIcon(status: string){
    if (status=='1')
      return {color: "#D30000",icon:"user-times"};
    if (status=='2')
      return {color: "darkkhaki",icon:"arrows-alt-h"};
    if (status=='3')
      return {color: "#D30000",icon:"times-circle"};
    return {};
  }

  flagLabels(flags: number): string[]{
    let rv=[];
    if (flags & 1 && !this.auth.isCoordinator) rv.push({tip:'Occupation needed',color:"#3C807E",icon: "user"});
    if (flags & 2 && !this.auth.isCoordinator) rv.push({tip:'License type needed',color:"#7B7832",icon: "id-card"});
    if (flags & 4) rv.push({tip:'Transfer request',color:"#BF5127",icon: "exchange"});
    if (flags & 8) rv.push({tip:'Licenses issued needed',color:"#08263A",icon: "list-ol"});
    return rv;
  }
  
  saveList() {
    let list=[];
    this.licenses.forEach(l=> {if (this.filterResults(l))
      list.push(l.id);
    });
    sessionStorage.setItem("liclist",JSON.stringify(list));
  }  
 }
